<template>
    <div class="wrapper wrapper3">
        <h3>完成指定任务，获取抽奖次数</h3>
        <Speakers />
        <div class="inner">
            <div class="action">
                <div class="btn btn-reward" @click="getMyRewards">我的奖品</div>
                <div class="btn btn-rule" @click="showRule">活动规则</div>
            </div>
        </div>
        <Lottery />
    </div>
    <Teleport to=".container">
        <RewardsPop ref="rewardsRef" />
        <RuelPop ref="ruleRef" />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, inject } from "vue";
import Speakers from "./components/speakers.vue";
import Lottery from "./components/lottery";
import useStore from "@/store/store.js";
import RuelPop from "./components/pop-rule.vue";
import RewardsPop from "./components/pop-rewards.vue";
const { user } = storeToRefs(useStore());
const loginRef = inject("loginRef");
const bindRef = inject("bindRef");
const rewardsRef = ref(null);
const ruleRef = ref(null);

// 我的抽奖记录
const getMyRewards = () => {
    if (!user.value.islogin) {
        return loginRef.value.Show();
    }
    if (!user.value.rolename) {
        return bindRef.value.Show();
    }
    rewardsRef.value.Show();
};

// 查看活动规则
const showRule = () => {
    ruleRef.value.Show();
    console.log("查看活动规则");
    CsGame.eventRecord(2, "查看抽奖活动规则");
};
</script>

<style lang="scss" scoped>
.wrapper3 {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/4.jpg");
    height: 1230px;
    padding-top: 130px;
    h3 {
        color: #c2a481;
        text-align: center;
        margin-bottom: 10px;
    }
    .action {
        position: absolute;
        display: flex;
        align-items: center;
        right: 0px;
        top: -40px;
        .btn {
            margin-left: 12px;
            padding: 6px 12px;
            font-size: 14px;
            background-color: #e2a13e;
            color: #462e1f;
            border-radius: 4px;
            cursor: pointer;
            &:hover {
                background-color: #f0b45c;
                color: #462e1f;
            }
        }
    }
}
</style>
